
// import { FaStar } from "react-icons/fa";
// import "./review.scss";
// export default function Reviews({ review }) {
//   return (<div className="testimonial-card">
//     <div className="testimonial-top">
//       <div className="stars">
//         {[1, 2, 3, 4, 5].map((i) =>
//           (<FaStar key={i} className={i <= review.stars ? "star active" : "star"} />))}
//       </div> <span className="review-date">{review.date}</span> </div>
//     <p className="testimonial-message"> {review.message} </p>
//     <div className="testimonial-footer">
//       <div className="avatar"> {review.name.charAt(0)} </div>
//       <div className="author-info"> <h4>{review.name}</h4>
//         <span>Verified Traveler</span>
//       </div> </div> </div>);
// }
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaStar, FaQuoteLeft } from "react-icons/fa";
import { FiMessageSquare } from "react-icons/fi";
import ReviewCard from "./ReviewCard";
import RatingForm from "./ReviewForm";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./review.scss";

export default function ReviewsSection({ reviews, itemId, tripName }) {
  const [showForm, setShowForm] = useState(false);
  
  // Calculate average rating
  // const averageRating = reviews.length > 0 
  //   ? (reviews.reduce((acc, review) => acc + review.stars, 0) / reviews.length).toFixed(1)
  //   : 0;
const validReviews = reviews.filter(r => typeof r.stars === "number");

const averageRating =
  validReviews.length > 0
    ? (
        validReviews.reduce((acc, r) => acc + r.stars, 0) /
        validReviews.length
      ).toFixed(1)
    : "0.0";

  // Calculate rating distribution
  const ratingDistribution = [5, 4, 3, 2, 1].map(star => ({
    stars: star,
    count: reviews.filter(r => r.stars === star).length,
    percentage: reviews.length > 0 
      ? (reviews.filter(r => r.stars === star).length / reviews.length) * 100 
      : 0
  }));

  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <div className="section-header">
          <div className="header-content">
            <span className="section-subtitle">Customer Feedback</span>
            <h2 className="section-title">
              Traveler <span>Reviews</span>
            </h2>
            <p className="section-description">
              See what our adventurers have to say about their experience
            </p>
          </div>

          <div className="rating-overview">
            <div className="average-rating">
              <div className="rating-number">{averageRating}</div>
              <div className="rating-stars">
                {[1, 2, 3, 4, 5].map((i) => (
                  <FaStar
                    key={i}
                    className={i <= averageRating ? "star active" : "star"}
                  />
                ))}
              </div>
              <div className="rating-count">{reviews.length} reviews</div>
            </div>
          </div>
        </div>

        <div className="reviews-grid">
          <div className="stats-sidebar">
            <div className="rating-breakdown">
              <h4>Rating Breakdown</h4>
              {ratingDistribution.map((item) => (
                <div key={item.stars} className="rating-bar">
                  <div className="stars">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <FaStar
                        key={i}
                        className={i <= item.stars ? "star active" : "star"}
                      />
                    ))}
                  </div>
                  <div className="bar-container">
                    <div 
                      className="bar-fill" 
                      style={{ width: `${item.percentage}%` }}
                    ></div>
                  </div>
                  <div className="bar-count">{item.count}</div>
                </div>
              ))}
            </div>

            <button 
              className="write-review-btn"
              onClick={() => setShowForm(!showForm)}
            >
              <FiMessageSquare /> {showForm ? 'Hide Form' : 'Write a Review'}
            </button>
          </div>

          <div className="reviews-main">
            {showForm && (
              <div className="form-container">
                <RatingForm itemId={itemId} tripName={tripName} />
              </div>
            )}

            {reviews.length > 0 ? (
              <>
                <div className="reviews-slider">
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={24}
                    slidesPerView='auto'
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 5000 }}
                    // breakpoints={{
                    //   640: { slidesPerView: 1 },
                    //   768: { slidesPerView: 2 },
                    //   1024: { slidesPerView: 3 },
                    // }}
                  >
                    {reviews.map((review, index) => (
                      <SwiperSlide key={index}>
                        <ReviewCard review={review} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                {/* <div className="all-reviews-grid">
                  {reviews.map((review, index) => (
                    <ReviewCard key={index} review={review} />
                  ))}
                </div> */}
              </>
            ) : (
              <div className="empty-reviews">
                <div className="empty-icon">
                  <FaQuoteLeft />
                </div>
                <h3>No Reviews Yet</h3>
                <p>Be the first to share your experience!</p>
                <button 
                  className="cta-btn"
                  onClick={() => setShowForm(true)}
                >
                  Write First Review
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}